export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOADING_CHANGE = "LOADING_CHANGE";
export const USER_UPDATED = "USER_UPDATED";
export const USER_UPDATE_FAILED = "USER_UPDATE_FAILED";
export const LOGOUT = "LOGOUT";
export const STUDENT_LOADED = "STUDENT_LOADED";
export const STUDENT_LOAD_FAIL = "STUDENT_LOAD_FAIL";
export const PRODUCT_ADDED_CART = "PRODUCT_ADDED_CART";
export const PRODUCT_CART_ADD_FAILED = "PRODUCT_CART_ADD_FAILED";
export const CART_FETCH_SUCCESS = "CART_FETCH_SUCCESS";
export const CART_FETCH_UPDATE_FAIL = "CART_FETCH_UPDATE_FAIL";
export const ITEM_DELETE_SUCCESS = "ITEM_DELETE_SUCCESS";
export const ITEM_DELETE_FAIL = "ITEM_DELETE_FAIL";
export const CART_LOADING_CHANGE = "CART_LOADING_CHANGE";
export const ORDER_PLACED_SUCCESSFULLY = "ORDER_PLACED_SUCCESSFULLY";
export const ORDER_PLACEMENT_FAIL = "ORDER_PLACEMENT_FAIL";
export const UPDATE_CART_ITEMS = "UPDATE_CART_ITEMS";
export const CLEAR_PRODUCT = "CLEAR_PRODUCT";
export const LOGIN_WITH_DEFAULT_PASSWORD = "LOGIN_WITH_DEFAULT_PASSWORD";
